import { useI18n } from "@wojo/localization";
import { DepartureHit } from "@wojo/services";
import { StoryblokImage } from "@wojo/storyblok";
import { Text } from "@wojo/ui";
import React from "react";
import { TripBuilderDepartureDetailType } from "../../../_client/context";
import { useTripBuilder } from "../context/TripBuilderContext";
import styles from "./TripBuilderDeparturesStep.module.scss";

type DepartureListFlexCellProps = {
    departure: DepartureHit;
};

export const DepartureListFlexCell: React.FC<DepartureListFlexCellProps> = ({
    departure,
}) => {
    const { departureDetailType } = useTripBuilder();
    const { productPage } = useI18n("productPage");

    const classLevel = departure.classLevel?.name;
    const classLevelIcon = departure.classLevel?.icon;

    const renderDetailType = () => {
        switch (departureDetailType) {
            case TripBuilderDepartureDetailType.ClassLevel:
                return (
                    <Text.Body
                        tag="span"
                        style={{
                            display: "flex",
                            gap: "var(--g-spacing-xs)",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    >
                        {!!classLevelIcon?.filename && (
                            <StoryblokImage
                                mobile={{
                                    asset: classLevelIcon,
                                }}
                                aria-hidden
                                style={{
                                    height: "1lh",
                                    display: "flex",
                                }}
                            />
                        )}
                        {classLevel}
                    </Text.Body>
                );
            case TripBuilderDepartureDetailType.Extension:
            default:
                return (
                    <Text.Body tag="span">
                        {departure.hasExtensionAvailable &&
                            productPage.tripBuilder.departures.hasExtensionValue.l()}
                    </Text.Body>
                );
        }
    };
    return (
        <td className={styles["table-cell"]} style={{ textAlign: "center" }}>
            {renderDetailType()}
        </td>
    );
};
